<template>
    <div class="views-content--solution">
        <banner-study :data="data.hero"></banner-study>

          <!-- elements -->
        <div v-for="element in data.elements" :key="element.id">
            <component class="space-bottom--md" :is="element.vueName" :data="element"/>
        </div>
    </div>
</template>

<script>
    import { BannerStudy } from "../components";

    // elements
    import { ElementAccordion,ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";

    export default {
        name: "v-solution",
        components: {
            BannerStudy,
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage,
            ElementForm
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {}
        },
        methods: {

        },
        created() {

        }
    };
</script>

<style lang="scss" scoped>
    
</style>
